import React from 'react';
import './Info.css';

const HOVER_COLORS = ['#ffc964', '#d65952', '#7ec28a', '#6ba1cf', '#a089f1'];
const randomColor = () => HOVER_COLORS[Math.floor(Math.random() * HOVER_COLORS.length)];

const CONTACT_LINKS = [
  { href: 'mailto:lukeabcstudio@gmail.com', label: 'lukeabcstudio@gmail.com' },
  { href: 'https://www.linkedin.com/in/lukeabc/', label: 'LinkedIn', external: true },
];

export default function Contact() {
  return (
    <div>
      <div className="home-container small-width">
        <div className="container">
          <ul className="info-links">
            {CONTACT_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="title-link-secondary"
                  style={{ '--hover-color': randomColor() }}
                  {...(link.external ? { target: '_blank', rel: 'noreferrer' } : {})}
                >
                  <span className="title-text-secondary">{link.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
